<div class="wrap-popup">
  <div class="header">
    <div class="que-info">
      <que-logo-display [isPopup]="true"></que-logo-display>
      <div class="que-name">
        <span translate>column.approvals.sendQuestionnaire</span>:
        {{ data.name }}
      </div>
    </div>
  </div>

  <div class="body">
    <div class="wrap-approvers">
      <p class="text" translate>column.approvals.approverAdmins</p>
      <div class="approvers">
        <div class="warp-input-select">
          <div class="selected-roles" *ngIf="approversToDisplay().length">
            <div class="selected-role" *ngFor="let item of approversToDisplay(); let i = index">
              <div class="selected-role-info">
                <span class="selected-role-number">{{ i + 1 }}.</span>
                <div class="icon-user" *ngIf="item.user">
                  <p>
                    {{item.user?.firstName?.charAt(0)?.toUpperCase()}}{{item.user?.lastName?.charAt(0)?.toUpperCase()}}
                  </p>
                </div>
                <p class="selected-role-text">{{item.user ? (item.user.firstName+" "+item.user.lastName) : item.groupName}}</p>
              </div>

              <button *ngIf="isFreeApproverSelection$()" type="button" class="remove-role" (click)="removeAdmin(item, $event)">
                <svg-icon class="icon" svgClass="icon-close" src="/assets/images/close.svg"></svg-icon>
              </button>
            </div>
          </div>
          <div #adminsOrigin="cdkOverlayOrigin" cdkOverlayOrigin>
            <div *ngIf="isFreeApproverSelection$() && (approversToDisplay().length < 2)" (click)="openAdminsDropdown()" class="input-select">
              <img src="/assets/images/steps/add-step.svg">
              <p class="select" translate>questionnaireSettings.addRole</p>
            </div>
          </div>
          <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="adminsOrigin"
            [cdkConnectedOverlayHasBackdrop]="true" (backdropClick)="openSelectAdmins = false"
            [cdkConnectedOverlayOpen]="openSelectAdmins" cdkConnectedOverlayBackdropClass="backdrop-selection"
            [cdkConnectedOverlayPositions]="positonArea">
            <ng-container>
              <div class="overlay-warp">
                <que-autocomplete-filter class="autocomplete-filter" [formControl]="valueControl"
                  [autoCompleteList]="approvers$()"
                  [selected]="selectedApproverIds$()">
                </que-autocomplete-filter>
              </div>
            </ng-container>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <div>
    <div class="divider"></div>
  </div>

  <div class="footer">
    <div class="btns">
      <button type="button" class="cancel pointer" (click)="close()">
        <p translate>header.viewAnswers.cancel</p>
      </button>

      <button type="button" class="save pointer" (click)="confirm()" [disabled]="!validateApprovers()">
        <p translate>header.viewAnswers.send</p>
      </button>
    </div>
  </div>
</div>